export default __webpack_public_path__ + "static/4-bdb47ae5416df216d244137817922888.jpeg";